var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mega_image",class:{ filler_detail_image: !_vm.megaImageCopy },style:('background-image: url(' +
      (_vm.megaImageCopy ? _vm.megaImageCopy : _vm.logoLight) +
      ')')},[_c('a',{staticClass:"close_button round light ml-2 mt-2",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.cleverBackToList()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }